<template lang="pug">
  .product-price
    template(v-if="price.sale_price")
      del.d-inline-block
        span.product-price-amount
          bdi.text-muted {{ price.regular_price | formatMoney }}
      ins
        span.product-price-amount
          bdi.text-primary
            strong {{ price.price | formatMoney }}
            small  บาท

    span.product-price-amount(v-else)
      bdi.text-primary
        strong {{ price.price | formatMoney }}
        small  บาท
</template>

<script>
export default {
  props: {
    price: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
